import { useQuery } from "@tanstack/react-query";
import axios from "axios";

interface TtsConfigPayload {
    baseUrl: string;
    agent_id: string;
    tenant_id: string;
    workspace_id: string;
}

export interface TtsConfig {
    id: string;
    name: string;
    language: string;
    display_img: string;
    display_text: string;
    tts_config_id: string;
}

export const getTtsConfigsByAgent = async (payload: TtsConfigPayload): Promise<TtsConfig[]> => {
    const { baseUrl, agent_id } = payload;
    const response = await axios.get(`${baseUrl}/agent-tts/${agent_id}`);

    console.log("Printing the tts config", response.data);

    return response.data;
};

export const useTtsConfigsQuery = (payload: TtsConfigPayload) => {
    return useQuery({
        queryKey: ["ttsConfigs", payload.agent_id],
        queryFn: () => getTtsConfigsByAgent(payload),
        enabled: !!payload.agent_id
    });
};
